import {
    MenuItemProps,
    useTranslations,
    useUrlParamsValueToString,
} from "@bsm/component";

export const useHolidayViewerMenu = (): Array<MenuItemProps> => {
    const [SCHOOL_HOLIDAY, PUBLIC_HOLIDAY] = useTranslations(i18n);
    const urlParams = useUrlParamsValueToString()

    const linkFn = (menu: MenuItemProps, index: number) => {
        return `${menu.link}?${urlParams}`
    }

    return [
        {
            ke: "school_holiday",
            label: SCHOOL_HOLIDAY,
            link: `school-holiday`,
            linkFn: linkFn,
        },
        {
            ke: "public_holiday",
            label: PUBLIC_HOLIDAY,
            link: `public-holiday`,
            linkFn: linkFn,
        }
    ];
};

const i18n = [
    "std_school_holiday",
    "std_public_holiday",
];
